/** Login page content — frontend-only for /login */

import { pageRoute, appRoute } from "./paths.js";

export const loginPage = {
  documentTitle: "Taldel — Log in",
  hero: {
    titleSegments: [
      { text: "Welcome ", highlight: null },
      { text: "back", highlight: "primary" },
      { text: " to ", highlight: null },
      { text: "Taldel", highlight: "secondary" },
      { text: ".", highlight: null },
    ],
    subtitle:
      "Sign in to continue with your Taldel workspace. Frontend-only for now — no session is created on a server yet.",
  },
  form: {
    eyebrow: "Sign in",
    heading: "Log in to your account",
    submitLabel: "Log in",
    fields: [
      {
        name: "email",
        type: "email",
        placeholder: "Work email",
        autocomplete: "email",
        required: true,
      },
      {
        name: "password",
        type: "password",
        placeholder: "Password",
        autocomplete: "current-password",
        required: true,
        minlength: 8,
      },
    ],
    registerPrompt: "New to Taldel?",
    registerLabel: "Create an account",
    registerHref: pageRoute("signup"),
  },
  success: {
    title: "You're signed in",
    body:
      "Thanks — your login details stayed on this page only. When backend auth ships, this flow will open a real Taldel session.",
    primaryLabel: "Back to home",
    primaryHref: appRoute("hero"),
    secondaryLabel: "Browse Our Portfolios",
    secondaryHref: pageRoute("our-portfolios"),
  },
};

export function getLoginPage() {
  return loginPage;
}

export function loginRoute(section = "") {
  return pageRoute("login", section);
}
